/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Provider_GbpInputs */

const cs_integrations_provider_gbp = /** @type {(inputs: Integrations_Provider_GbpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business`)
};

const en_integrations_provider_gbp = /** @type {(inputs: Integrations_Provider_GbpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business`)
};

/**
* | output |
* | --- |
* | "Google Business" |
*
* @param {Integrations_Provider_GbpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_provider_gbp = /** @type {((inputs?: Integrations_Provider_GbpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Provider_GbpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_provider_gbp(inputs)
	return cs_integrations_provider_gbp(inputs)
});